import { GSButton, GSInfoGroup } from "golfstatus_react_components";
import React from "react";
import { moneyWithCommas } from "../../../../helpers/RegexHelper";

import "./tournament-packages-item.scss";
import {faClone, faEye, faEyeSlash, faHourglassEnd} from "@fortawesome/free-solid-svg-icons";

const TournamentPackagesItem = (props) => {
  const {
    id,
    name,
    packageType,
    cost,
    remainingPackages,
    state,
    purchasedCount,
    activateOn,
    deactivateOn,
    copyPackage,
    hasTechPackageItem,
  } = props;

  const infoSection = {
    sectionItems: [
      {
        type: "primary no-wrap full-width",
        value: name,
      },
      {
        type: "secondary no-wrap full-width capitalize",
        value: `${packageType} package`,
      },
      {
        type: "secondary no-wrap full-width",
        value: moneyWithCommas(cost),
      },
    ],
  };

  const purchaseSection = {
    sectionItems: [
      {
        type: "secondary no-wrap full-width",
        value: `${purchasedCount} Purchased`,
      },
      {
        type: "secondary no-wrap full-width",
        value: `${remainingPackages} Remaining`,
      },
    ],
  };

  const stateSection = () => {
    let title = state, css = title;
    let icon = faEye;

    const currentTime = new Date().toISOString();

    if (state === "active") {
      if (deactivateOn && currentTime > deactivateOn) {
        title = "deactivated";
        css = "inactive";
        icon = faHourglassEnd;
      } else if (activateOn && currentTime < activateOn) {
        title = "inactive";
        css = "inactive";
        icon = faHourglassEnd;
      }
    } else {
      title = "inactive";
      css = "inactive";
      icon = faEyeSlash;
    }

    return {
      sectionItems: [
        {
          type: "primary no-wrap full-width",
          value: (
            <GSButton
              type={`status ${css} secondary pill`}
              title={title}
              buttonIcon={icon}
            />
          ),
        },
      ],
    };
  };

  const copyButton = {
    sections: [
      {
        sectionItems: [
          {
            type: "primary full-width",
            value: (
              <GSButton
                type="mobile-icon light-grey"
                buttonIcon={faClone}
                title={"Copy"}
                onClick={(e) => {
                  copyPackage?.(id);
                  e?.stopPropagation?.();
                }}
              />
            ),
          },
        ],
      },
    ],
  };

  const infoColumn = {
    fit: "stretch",
    sections: [
      {
        ...infoSection,
      },
      purchaseSection,
      stateSection(),
    ],
  };

  const getGroup = () => {
    let group = [{ ...infoColumn }];
    if (copyPackage && !hasTechPackageItem) {
      group.push({...copyButton});
    }
    return group;
  };

  return (
    <tournament-packages-item>
      <GSInfoGroup dataGroups={getGroup()}></GSInfoGroup>
    </tournament-packages-item>
  );
};

export default TournamentPackagesItem;
